import { render, staticRenderFns } from "./Unidad_Medida.vue?vue&type=template&id=b8951ddc&"
import script from "./Unidad_Medida.vue?vue&type=script&lang=js&"
export * from "./Unidad_Medida.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports